// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1241":"1e69e967","1251":"d2745d85"}[chunkId] + ".chunk.css";
};